var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.072 28.935",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "play-button-arrowhead (1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.724.638C2.115-.858 0 .367 0 3.374v22.185c0 3.009 2.115 4.234 4.724 2.739l19.39-11.121c2.61-1.5 2.61-3.922 0-5.419Z",
    "data-name": "Pfad 593"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;